var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useHistory } from "react-router-dom";
import useSnackbar from "./useSnackbar";
export function useEntitySaver(save) {
    var _this = this;
    var _a = useState({
        tag: "initial",
    }), feedback = _a[0], setFeedback = _a[1];
    var history = useHistory();
    var _b = useSnackbar(), snackbaractions = _b[1];
    var handleError = function (response) {
        var _a, _b;
        if (!response.ok) {
            if (response.problem === "NETWORK_ERROR") {
                snackbaractions.setSnackBar({
                    message: "Não foi possível fazer a requisição. Servidor fora do ar ou internet não disponível",
                    severity: "error",
                });
            }
            if (response.problem === "CLIENT_ERROR") {
                snackbaractions.setSnackBar({
                    message: ((_a = response.data) === null || _a === void 0 ? void 0 : _a.message) || "Não foi possível salvar os dados",
                    severity: "error",
                });
            }
            if (response.problem === "SERVER_ERROR") {
                snackbaractions.setSnackBar({
                    message: ((_b = response.data) === null || _b === void 0 ? void 0 : _b.message) || "Erro interno do servidor",
                    severity: "error",
                });
            }
        }
        setFeedback({ tag: "error", error: "Ocorreu um erro" });
    };
    var getPath = function () {
        return location.pathname
            .split('/')
            .filter(Boolean)
            .slice(0, -1)
            .join('/');
    };
    var doSave = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, save(data)];
                case 1:
                    response = _a.sent();
                    if (response.ok && response.data) {
                        setFeedback({
                            tag: "sucess",
                            message: "Salvo com sucesso",
                        });
                        snackbaractions.setSnackBar({
                            message: "Salvo com sucesso!",
                            severity: "success",
                        });
                        history.replace("/" + getPath() + "/" + response.data.id);
                        return [2 /*return*/, response];
                    }
                    handleError(response);
                    return [2 /*return*/, response];
            }
        });
    }); };
    var saveWithoutRedirect = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, save(data)];
                case 1:
                    response = _a.sent();
                    if (response.ok && response.data) {
                        setFeedback({
                            tag: "sucess",
                            message: "Salvo com sucesso",
                        });
                        snackbaractions.setSnackBar({
                            message: "Salvo com sucesso!",
                            severity: "success",
                        });
                        return [2 /*return*/, response];
                    }
                    handleError(response);
                    setFeedback({ tag: "error", error: "Ocorreu um erro" });
                    return [2 /*return*/, response];
            }
        });
    }); };
    return { feedback: feedback, save: doSave, saveWithoutRedirect: saveWithoutRedirect };
}
//# sourceMappingURL=useEntitySaver.js.map